import React, { useEffect, useState } from "react";
import { Modal, Button, MenuItem, Box, Typography } from "@mui/material";
import { MdClose } from "react-icons/md";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useDispatch, useSelector } from "react-redux";
import successimage from "../../../../Assets/images/ILL_Sucess.png";
import classes from "../customer.module.css";
import { fetchTeams, assignSubscriptionToTeam } from "../../../../Redux/actions/customerActions";
import { fetchSubscriptions } from "../../../../Redux/actions/subscriptionAction";
import { DatePickerCalendarIcon } from "../../../../Components/Icons/Icons";

const AddSubscriptionModal = ({ customerId, modalClose, onAssigned }) => {
  const dispatch = useDispatch();
  const rootRef = React.useRef(null);

  const [modalToggle, setModalToggle] = useState(true);
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const [teamId, setTeamId] = useState("");
  const [subscriptionId, setSubscriptionId] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [durationType, setDurationType] = useState("Monthly");

  const { teams } = useSelector((state) => state.customerData);
  const { subscriptions: plans } = useSelector((state) => state.subscriptions);

  useEffect(() => {
    dispatch(fetchTeams(customerId));
    dispatch(fetchSubscriptions(1, 100, "", "packageName-asc"));
  }, [customerId, dispatch]);

  const closeModal = () => {
    modalClose(false);
    setModalToggle(false);
  };

  const handleSubmit = async () => {
    setError("");
    if (!startDate) {
      setError("Start date is required");
      return;
    }
    setSubmitting(true);
    try {
      const start = startDate.toDate();
      const end = new Date(start);
      if (durationType === "Monthly") {
        end.setDate(start.getDate() + 30);
      } else {
        end.setDate(start.getDate() + 365);
      }

      await dispatch(
        assignSubscriptionToTeam({
          teamId,
          subscriptionId,
          startDate: start.toISOString(),
          endDate: end.toISOString(),
        })
      );

      setSuccess(true);
      if (onAssigned) onAssigned();
    } catch (err) {
      setError(
        err.response?.data?.message || err.message || "Failed to add subscription"
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <Modal
        open={modalToggle}
        aria-labelledby="add-subscription-modal-title"
        data-testid="add_subscription_modal"
        sx={{ display: "flex", alignItems: "center", justifyContent: "center", p: 2 }}
        container={() => rootRef.current}
      >
        <Box className={classes.modalPaper}>
          <Button
            variant="text"
            sx={{ minWidth: "unset" }}
            className={classes.closebtn}
            onClick={closeModal}
          >
            <MdClose />
          </Button>
          {!success && (
            <div className={classes.AddMemberHeading}>
              <Typography>Add Subscription</Typography>
            </div>
          )}
          {!success ? (
            <ValidatorForm useref="form" onSubmit={handleSubmit} className={classes.modalForm}>
              <div className={classes.modalScrollBody}>
                <div className={classes.depFormContainer}>
                  <div>
                    <div className="mt-3 mb-3">
                      <Typography className={classes.form_lable}>Team*</Typography>
                      <TextValidator
                        sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, width: "100%" }}
                        select
                        value={teamId}
                        onChange={(e) => setTeamId(e.target.value)}
                        size="small"
                        validators={["required"]}
                        errorMessages={["Please select a team"]}
                      >
                        {teams?.map((team) => (
                          <MenuItem key={team._id} value={team._id}>
                            {team.team_name}
                          </MenuItem>
                        ))}
                      </TextValidator>
                    </div>
                  </div>
                  <div>
                    <div className="mb-3">
                      <Typography className={classes.form_lable}>Plan*</Typography>
                      <TextValidator
                        sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, width: "100%" }}
                        select
                        value={subscriptionId}
                        onChange={(e) => setSubscriptionId(e.target.value)}
                        size="small"
                        validators={["required"]}
                        errorMessages={["Please select a plan"]}
                      >
                        {plans?.map((plan) => (
                          <MenuItem key={plan._id} value={plan._id}>
                            {plan.packageName}
                          </MenuItem>
                        ))}
                      </TextValidator>
                    </div>
                  </div>
                  <div>
                    <div className="mb-3">
                      <Typography className={classes.form_lable}>Start Date*</Typography>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          value={startDate}
                          onChange={(newValue) => setStartDate(newValue)}
                          format="DD/MM/YYYY"
                          slots={{ openPickerIcon: DatePickerCalendarIcon }}
                          slotProps={{
                            textField: {
                              size: "small",
                              fullWidth: true,
                              sx: {
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                              },
                            },
                          }}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div>
                    <div className="mb-3">
                      <Typography className={classes.form_lable}>Duration*</Typography>
                      <TextValidator
                        sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, width: "100%" }}
                        select
                        value={durationType}
                        onChange={(e) => setDurationType(e.target.value)}
                        size="small"
                      >
                        <MenuItem value="Monthly">Monthly (30 days)</MenuItem>
                        <MenuItem value="Yearly">Yearly (365 days)</MenuItem>
                      </TextValidator>
                    </div>
                  </div>
                  {error && (
                    <Typography style={{ color: "#c0392b", fontSize: 13 }}>{error}</Typography>
                  )}
                </div>
              </div>
              <div className={classes.modalFooter}>
                <Button variant="contained" type="submit" fullWidth disabled={submitting}>
                  {submitting ? "Adding..." : "Add Subscription"}
                </Button>
              </div>
            </ValidatorForm>
          ) : (
            <div className={classes.addMembersuccess}>
              <img src={successimage} alt="Success logo" width={200} height={200} />
              <Typography className={classes.successMainText}>
                Subscription Added Successfully
              </Typography>
              <Typography className={classes.successSubText}>
                The team now has an active subscription.
              </Typography>
            </div>
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default AddSubscriptionModal;
